import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router";
// constants
import ROLES from '../../constants/Roles';
// -- dialogs:
import Dialog from 'material-ui/Dialog';
import LoadingDialog from '../Common/LoadingDialog';
import CourseEnrolmentAddDialog from './CourseEnrolmentAddDialog';
import CourseEnrolmentEditDialog from './CourseEnrolmentEditDialog';
// -- other:
import AddEntityActionButton from '../Common/AddEntityActionButton';
import CourseEnrolmentTableRow from './CourseEnrolmentTableRow';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';
import Snackbar from 'material-ui/Snackbar';
import TableView from '../Common/TableView';
// -- icons:
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import FilterIcon from 'material-ui/svg-icons/content/filter-list';
import InfoIcon from 'material-ui/svg-icons/action/info';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import TimeLineIcon from 'material-ui/svg-icons/action/timeline';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
//business logic:
import buildContextMenu from '../Common/BuildContextMenu';

import CourseStore from '../../stores/CourseStore';
import CourseEnrolmentStore from '../../stores/CourseEnrolmentStore';
import CourseActions from '../../actions/CourseActionCreator';
import MessageStore from '../../stores/MessageStore';
import SearchStore from '../../stores/SearchStore';
import { withId } from '../Common/Decorators';
import { SearchTypes } from '../../constants/CentricConstants';

const sortOptions = [
    { label: 'First Name',     value: 'firstName'     },
    { label: 'Last Name',      value: 'lastName'      },
    { label: 'Date Enrolled',  value: 'dateStart'     },
    { label: 'Date Completed', value: 'dateCompleted' }
];

const CourseEnrolments = React.createClass({

    getInitialState(){

        return {
            dialog: {
                open: false,
                value: null,
                data: null
            },

            open: false,
            searchText: '',
            details: {
                name: '',
                description: '',
                outline: '',
                instruction: '',
                cost: '',
                url: '',
                assessment: '',
                type: '',
                courseStatus: '',
                code: '',
                capacity: '',
                sendJoiningInstructions: false
            },
            enrolments: [],
            events: [],
            selected: [],
            successMessage: '',
            showSuccessMessage: false,
            page: 0,
            limit: 50,
            sort: null,
            sortCriteria: null,
            sortMapCriteria: null,
            searchPage: 0,
            searchMode: false,
            loading: false,
            fetchedAll: false,
            showButton: false,

            actions: [],
            links: {
                back: '/dashboard/course/' + this.props.id,
                edit: '',

            }
        }
    },

    componentDidMount(){

        this.setState({actions: buildContextMenu(this.getActions(), this.context.auth)});

        this.listeners = [
            CourseStore.addListener(this._onChange),
            MessageStore.addListener(this.onTaskCreate),
            SearchStore.addListener(this.onSearch)
        ];
        CourseActions.getById(this.props.id);

        CourseEnrolmentStore.addChangeListener(this._onEnrolmentsChange);
        CourseActions.getEnrolments(this.props.id, {limit: this.state.limit});

        window.addEventListener('scroll', this.handleScroll);
    },

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
        CourseStore.removeChangeListener(this._onChange);
        CourseEnrolmentStore.removeChangeListener(this._onEnrolmentsChange);
        window.removeEventListener('scroll', this.handleScroll);
    },

    render() {
        let dialog, props;
        switch (this.state.dialog.open) {
            case 'enrolment':
                dialog = <CourseEnrolmentAddDialog courseId={this.props.id} open={true} onClose={this._closeDialog}/>;
                break;

            case 'status':
                if (this.state.dialog.data !== null && this.state.dialog.data.hasOwnProperty('next') && this.state.enrolments.length > 0) {
                    let isMandatory = false, status = null, score = null, canRetake = null, dateStart = null, dateCompleted = null;
                    if (this.state.dialog.data.enrolments.length === 1) {
                        const enrolment = this.state.enrolments.find((e) => (e !== undefined && e.id === this.state.dialog.data.enrolments[0]));
                        isMandatory = !!enrolment.isMandatory;
                        status = enrolment.status;
                        score = enrolment.score;
                        canRetake = enrolment.canRetake;
                        dateStart = !!enrolment.dateStart ? new Date(enrolment.dateStart) : null;
                        dateCompleted = !!enrolment.dateCompleted ? new Date(enrolment.dateCompleted) : null;
                    }
                    dialog = (
                        <CourseEnrolmentEditDialog
                            open={true}
                            title={this.state.dialog.data.enrolments.length > 1 ? 'Edit enrolments' : 'Edit enrolment'}
                            enrolments={this.state.dialog.data.enrolments}
                            statusList={this.state.dialog.data.next}
                            data={{status, score, isMandatory, canRetake, dateStart, dateCompleted}}
                            onSave={this._changeEnrolmentStatus}
                            onClose={this._closeDialog}
                            onCancel={this._closeDialog}
                            closeOnSave
                        />
                    );
                } else {
                    const props = {title: "Enrolment status", open: true, buttonAction: this._closeDialog};
                    dialog = <LoadingDialog {...props} />;
                }
                break;

            case 'enrolmentByFilter':
                dialog = <CourseEnrolmentAddDialog courseId={this.props.id} open={true} onClose={this._closeDialog} byFilter/>;
                break;

            case 'confirmDelete':
                props = {
                    title: "Delete enrolments",
                    open: true,
                    modal: false,
                    onRequestClose: this._closeDialog,
                    actions: [
                        <FlatButton key="cancel" label="Cancel" onTouchTap={this._closeDialog}/>,
                        <FlatButton key="submit" label="Delete" onTouchTap={this._dialogSave}/>,
                    ]
                };

                dialog = (
                    <Dialog {...props} >
                        Are you sure you wish to delete these enrolments?
                    </Dialog>
                );
                break;

            case 'sendEmails':
                props = {
                    title: "Send enrolment emails",
                    open: true,
                    modal: false,
                    onRequestClose: this._closeDialog,
                    actions: [
                        <FlatButton key="cancel" label="Cancel" onTouchTap={this._closeDialog}/>,
                        <FlatButton key="submit" label="Send"   onTouchTap={this._dialogSave}/>,
                    ]
                };

                dialog = (
                    <Dialog {...props} >
                        Send enrolment emails to these users?
                        <br/><br/>
                        {this.state.details.sendJoiningInstructions && <em>Joining instructions emails will also be sent</em>}
                    </Dialog>
                );
                break;
        }

        const headers = [
            'Enrolment',
            'Name',
            'Completed',
            '',
            '',
            ''
        ];

        const filterOptions = [
            {label: 'Show all', value: null},
            ...CourseStore.getStatuses().map((e) => ({label: e.name, value: e.id}))
        ];

        return (
            <div ref="courseEnrolments">
                <TableView
                    title={(<Link to={`/dashboard/course/${this.props.id}`}>{this.state.details.name}</Link>)}
                    subtitle="Course enrolments"
                    headers={headers}
                    rows={this.state.enrolments}
                    decorator={CourseEnrolmentTableRow}
                    backButton={true}
                    backTo={this.state.links.back}
                    actions={this.state.actions}
                    multiSelectable={true}
                    enableSelectAll={true}
                    onRowSelection={this.onRowSelection}
                    itemActions={{
                        onEdit:     this._getStatusDialogOpener,
                        onDelete:   this._openDialog
                    }}
                    filterOptions={filterOptions}
                    filterAction={this.filter}
                    sortOptions={sortOptions}
                    sortAction={this.sort}
                    searchAction={this.search}
                    toggleSearchMode={this.toggleSearchMode}
                    searchType={SearchTypes.COURSE_ENROLMENTS}
                >
                    {this.state.loading && (
                        <LinearProgress mode="indeterminate" />
                    )}
                    {this.state.showButton && (
                        <FlatButton
                            label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                            icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                            onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                            disabled={this.state.loading}
                            fullWidth
                        />
                    )}
                    {this.context.auth.isAdmin() && (
                        <AddEntityActionButton onClick={this._openEnrolmentDialog}/>
                    )}
                    <Snackbar
                        open={this.state.showSuccessMessage}
                        action="OK"
                        message={this.state.successMessage}
                        onActionTouchTap={this.onCloseSnackbar}
                        onRequestClose={this.onCloseSnackbar}
                    />
                    {dialog}
                </TableView>
            </div>
        );
    },

    getActions(selected = []) {
        return [
            {
                link: `/dashboard/course/${this.props.id}`,
                icon: <InfoIcon />,
                label: 'Preview',
            },
            {
                type:'divider'
            },
            {
                icon: <FilterIcon />,
                label: 'Enrol by filter',
                action: () => {this._openDialog('enrolmentByFilter')},
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'divider'
            },
            {
                action: () => this._getStatusDialogOpener(selected),
                icon: <EditIcon/>,
                label: 'Edit status',
                condition: {
                    show: selected.length
                }
            },
            {
                action: () => this._openDialog('sendEmails'),
                icon: <EmailIcon/>,
                label: 'Send email',
                condition: {
                    show: selected.length && this.state.details.sendEmail
                }
            },
            {
                action: () => this._openDialog('confirmDelete'),
                icon: <DeleteIcon/>,
                label: 'Delete',
                condition: {
                    roles: [ROLES.ADMIN],
                    show: selected.length
                }
            },
            {
                type: 'divider'
            },
            {
                link: `/dashboard/course/${this.props.id}/settings`,
                icon: <SettingsIcon />,
                label: 'Settings',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
        ]
    },

    _onChange() {
        const course = CourseStore.getById(this.props.id);
        if (course !== undefined) {
            this.setState({details: course});
        }
    },

    _onEnrolmentsChange() {
        const enrolments = CourseEnrolmentStore.getByCourse(this.props.id);
        if (enrolments !== undefined) {
            const enrolmentList = enrolments.filter(function(e) { return e !== undefined && e.status !== 'none'; });
            if (CourseEnrolmentStore.fetchedAll()) {
                this.setState({fetchedAll: true});
            }
            if (enrolmentList.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({enrolments: enrolmentList, loading: false});
            } else {
                const mapped = enrolmentList.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sorted = mapped.map((el) => enrolmentList[el.index]);
                this.setState({enrolments: sorted, loading: false});
            }
        }
    },

    _openEnrolmentDialog() {
        this._openDialog('enrolment');
    },

    _getStatusDialogOpener(enrolments) {
        this._openDialog('status', null, {enrolments, next: CourseStore.getStatuses()});
    },

    _openDialog(open, value = null, data = null) {
        this.setState({dialog: {open, value, data}});
    },

    _closeDialog() {
        this.setState({dialog: {...this.state.dialog, open: false}});
    },

    _dialogSave() {
        let close = true;
        switch (this.state.dialog.open) {
            case 'confirmDelete':
                const enrolments = !!this.state.dialog.value ? [this.state.dialog.value] : this.state.selected;
                this._deleteEnrolment(enrolments);
                break;
            case 'sendEmails':
                CourseActions.sendEnrolmentEmails(this.state.selected);
                break;
            default:
                console.error('unhandled dialog');
                close = false;
        }

        if (close) this._closeDialog();
    },

    _deleteEnrolment(enrolmentIds) {
        if (enrolmentIds.length === 1) {
            const index = this.state.enrolments.findIndex((e) => (e !== undefined && e.id === enrolmentIds[0]));
            if (0 <= index) {
                CourseActions.deleteEnrolment(this.state.enrolments[index]);
            }
        } else if (enrolmentIds.length > 1){
            CourseActions.bulkDeleteEnrolments(enrolmentIds);
        }
    },

    _changeEnrolmentStatus(value) {
        const enrolmentIds = this.state.dialog.data.enrolments;
        if (enrolmentIds.length === 1) {
            const enrolment = this.state.enrolments.find((e) => (e !== undefined && e.id === enrolmentIds[0]));
            if (enrolment && (enrolment.status !== value.status || enrolment.isMandatory !== value.isMandatory || enrolment.score !== value.score)) {
                CourseActions.updateEnrolment(enrolment.courseId, enrolmentIds[0], value);
            }
        } else {
            let enrolments = [];
            this.state.enrolments.forEach((e) => {
                if (e !== undefined
                    && ((value.status !== undefined && e.status !== value.status)
                        || (value.isMandatory !== undefined && e.isMandatory !== value.isMandatory)
                        || (value.score !== undefined && e.score !== value.score))
                    && enrolmentIds.includes(e.id)
                ) {
                    enrolments.push(e.id);
                }
            });
            if (enrolments.length > 0) {
                CourseActions.bulkUpdateEnrolments(enrolments, value);
            }
        }
    },

    onRowSelection(selected) {
        let enrolments;
        switch (selected) {
            case 'none':
                if (this.state.selected.length === 0) { return; } // guard
                enrolments = [];
                break;
            case 'all':
                enrolments = this.state.enrolments.map(({id}) => (id));
                break;
            default:
                enrolments = selected.map((s) => (this.state.enrolments[s].id));
                break;
        }
        this.setState({
            selected: enrolments,
            actions: buildContextMenu(this.getActions(enrolments), this.context.auth)
        });
    },

    onTaskCreate() {
        this.setState({showSuccessMessage: true, successMessage: MessageStore.getLastMessage()});
    },

    onCloseSnackbar() {
        this.setState({showSuccessMessage: false});
    },

    filter({filter}) {
        let enrolments =  CourseEnrolmentStore.getByCourse(this.props.id);
        if (!!filter) {
            enrolments = enrolments.filter((e) => e.status === filter);
        }
        this.setState({enrolments});
    },

    sort ({sort}) {
        if (sort === this.state.sort) { return; }

        let sortCriteria, sortMapCriteria;
        switch (sort) {
            case 'firstName':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.firstName});
                break;
            case 'lastName':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.lastName});
                break;
            case 'dateStart':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateStart) || 0});
                break;
            case 'dateCompleted':
                sortCriteria = (a, b) => (b.value - a.value);
                sortMapCriteria = (el, i) => ({index: i, value: Date.parse(el.dateCompleted) || 0});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[sort]});
        }
        this.setState({sort, sortCriteria, sortMapCriteria, isLoading: true});
        CourseActions.getEnrolments(this.props.id, { sort, limit: this.state.limit }, true);
    },

    loadNextPage() {
        if (this.state.loading) { return; } //guard

        const page = !this.state.searchMode ? (this.state.page + 1) : (this.state.searchPage + 1);
        if (!this.state.searchMode) {
            CourseActions.getEnrolments(this.props.id, {page, limit: this.state.limit, sort: this.state.sort});
            this.setState({page, loading: true});
        } else if (!!this.state.searchText) {
            CourseActions.searchEnrolments(this.props.id, this.state.searchText, {page, limit: this.state.limit});
            this.setState({searchPage: page, loading: true});
        }
    },

    handleScroll() {
        if (!this.state.showButton && window.scrollY > 0) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) >= this.refs.courseEnrolments.clientHeight) {
            this.loadNextPage();
        }
    },

    onSearch() {
        this.setState({
            fetchedAll: this.state.searchMode && SearchStore.fetchedAll(),
            loading: this.state.searchMode && SearchStore.isFetching()
        });
    },

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { CourseActions.searchEnrolments(this.props.id, searchText, {limit: this.state.limit}) }, 500);

            this.setState({
                searchText,
                searchPage: 0,
                showButton: false,
                fetchedAll: (searchText !== this.state.searchText ? false : this.state.fetchedAll)
            });
        }
    },

    toggleSearchMode(searchMode) {
        this.setState({
            searchMode,
            fetchedAll: false,
            showButton: false,
            searchText: (searchMode ? this.state.searchText : null)
        });
    }
});

CourseEnrolments.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(CourseEnrolments);
